import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { NAVIGATION_SIDEBAR_WIDTH } from "app/pages/activation/constants/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const HeaderWrapper = styled(FlexColumn)`
    width: 100%;
    gap: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid ${carbon[100]};
    padding: 24px 44px 16px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 44px);

    @media (min-width: 1920px) {
        padding: 24px 120px 16px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 120px);
    }
`;

export const SectionWrapper = styled(FlexRow)`
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

export const LeftTitleWrapper = styled(FlexRow)`
    align-items: center;
    align-self: flex-start;
`;

const OutLink = styled.a`
    opacity: 0;
    margin-right: 8px;

    &:hover {
        transition: opacity 0.5s ease-out;
        opacity: 1;
    }

    & > path {
        fill: ${colorsPalettes.carbon[500]};
    }
`;

export const LinkWithTitle = styled.div`
    display: flex;
    flex-direction: row;

    &:hover > ${OutLink} {
        transition: opacity 0.5s ease-out;
        opacity: 1;
    }
`;

const Row = styled(FlexRow)`
    width: 100%;
    align-items: center;
    gap: 10px;
    padding: 0 24px;
`;

const Column = styled(FlexColumn)`
    width: 100%;
    height: 100%;
    align-items: start;
    gap: 10px;
`;
